import { LucideIcon, Search, BrainCircuit, Shield, Map, Rocket } from 'lucide-react'

export interface MethodologyStep {
    id: string
    number: number
    title: string
    description: string
    icon?: LucideIcon  // Ícone para a bolinha
}

export const methodology: MethodologyStep[] = [
    {
        id: 'mergulho-profundo',
        number: 1,
        title: 'Mergulho Profundo (AS-IS)',
        description: 'Levantamento detalhado da estrutura, processos, desafios e oportunidades atuais.',
        icon: Search,
    },
    {
        id: 'inteligencia-estrutura',
        number: 2,
        title: 'Inteligência e Estrutura',
        description: 'Análise de dados para recomendar a estrutura organizacional ideal e melhores práticas de governança.',
        icon: BrainCircuit,
    },
    {
        id: 'governanca-seguranca',
        number: 3,
        title: 'Governança de Dados e Segurança',
        description: 'Priorização das estratégias de gestão de dados com foco total em integridade e conformidade LGPD.',
        icon: Shield,
    },
    {
        id: 'mapa-capacidade',
        number: 4,
        title: 'Mapa de Capacidade de Negócio',
        description: 'Criação de diagramas de contexto que traduzem a estratégia em soluções claras, visualizando onde a tecnologia gera maior impacto.',
        icon: Map,
    },
    {
        id: 'plano-transformacao',
        number: 5,
        title: 'Plano de Transformação',
        description: 'Um guia pragmático com ações claras e priorizadas para curto, médio e longo prazo.',
        icon: Rocket,
    },
]
